// apps/embed/src/entries/chatBootHints.ts
//
// The FIRST import of entries/chat.tsx, before React and MUI: the API connection the chat's first call
// (`/chat/reference`) needs starts opening while the rest of chat.js evaluates (bootConnectionHints.ts).
import { addBootConnectionHints } from '@embed/entries/bootConnectionHints';

addBootConnectionHints('chat');
